module.exports = __webpack_public_path__ + "img/black-vip-device.7e2587c2.png";